var BackInStock = {

    selectors: {

        modal: null,
        overlay: null,
        buttonSubmit: null,
        inputEmail: null,
        inputVariantId: null,
        inputNewsletter: null,
        elementTitleProduct: null,
        containerFeedback: null,
        feedback: null,
        wrapperContent: null,

        getSelectors() {
            BackInStock.selectors.modal = document.querySelector(".e-backinstock-modal");
            BackInStock.selectors.overlay = document.querySelector(".e-backinstock-moda__overlay");
            BackInStock.selectors.buttonSubmit = document.querySelector(".e-backinstock__button");
            BackInStock.selectors.inputEmail = document.querySelector(".e-backinstock__field-email");
            BackInStock.selectors.inputVariantId = document.querySelector(".e-backinstock__field-variant-id");
            BackInStock.selectors.inputNewsletter = document.querySelector(".e-backinstock__checkbox");
            BackInStock.selectors.elementTitleProduct = document.querySelector(".e-backinstock__product-title");
            BackInStock.selectors.containerFeedback = document.querySelector(".e-backinstock__container-feedback");
            BackInStock.selectors.feedback = document.querySelector(".e-backinstock__feedback");
            BackInStock.selectors.wrapperContent = document.querySelector(".e-backinstock__wrapper-content");
        }

    },

    view: {
        openModal() {
            BackInStock.selectors.modal.classList.add("active");
            BackInStock.selectors.overlay.classList.add("active");
        },
    
        closeModal() {
            BackInStock.selectors.modal.classList.remove("active");
            BackInStock.selectors.overlay.classList.remove("active");

            BackInStock.selectors.wrapperContent.classList.remove("disabled");
            BackInStock.selectors.containerFeedback.classList.remove("active");
            BackInStock.selectors.feedback.classList.remove("success");
            BackInStock.selectors.feedback.classList.remove("error");
        },
    },

    handles: {

        modal(event, productVariantId, productTitle) {
            BackInStock.selectors.containerFeedback.classList.remove("active");
            BackInStock.selectors.elementTitleProduct.textContent = productTitle;
            BackInStock.selectors.inputVariantId.value = productVariantId;
            BackInStock.view.openModal();
        },

        async submit() {
            const email = BackInStock.selectors.inputEmail.value;
            const variantId = BackInStock.selectors.inputVariantId.value;
            const patternEmail = /\S+@\S+\.\S+/;
            const emailIsValid = patternEmail.test(email);

            if(!emailIsValid) {
                BackInStock.selectors.wrapperContent.classList.remove("disabled");
                BackInStock.selectors.containerFeedback.classList.add("active");
                BackInStock.selectors.feedback.classList.remove("success");
                BackInStock.selectors.feedback.classList.add("error");
                BackInStock.selectors.feedback.textContent = "enter a valid email address.";
                return
            }

            BackInStock.selectors.buttonSubmit.textContent = "send...";

            try {
                await BackInStock.klayiyo.sendData({ email, variantId });

                BackInStock.selectors.wrapperContent.classList.add("disabled");
                BackInStock.selectors.containerFeedback.classList.add("active");
                BackInStock.selectors.feedback.classList.remove("error");
                BackInStock.selectors.feedback.classList.add("success");
                BackInStock.selectors.feedback.textContent = "thank you, your email has been registered!";
                BackInStock.selectors.buttonSubmit.textContent = "enviar";
                
            } catch (error) {
                BackInStock.selectors.buttonSubmit.textContent = "enviar";

                BackInStock.selectors.wrapperContent.classList.remove("disabled");
                BackInStock.selectors.containerFeedback.classList.add("active");
                BackInStock.selectors.feedback.classList.remove("success");
                BackInStock.selectors.feedback.classList.add("error");
                BackInStock.selectors.feedback.textContent = "error registering, please try again.";
            }
        },

    },

    klayiyo: {
        async sendData({ email, variantId }) {
            

            var obj = { a: "RMCeiR", platform: "shopify", email, variant: variantId, subscribe_for_newsletter: true };

            $.ajax({
                url: 'https://a.klaviyo.com/onsite/components/back-in-stock/subscribe',
                type: "POST",
                data: obj,
                headers: {
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
                },
                success: function (response) {
                    console.log('sucesso', response);
                },
                error: function (error) {
                    console.log('error', error);
                }
            });


        },
    },

    pages: {

        product() {
            const buttonSubmitForm = document.querySelector(".e-back-in-stock-product__submit");
            if(!buttonSubmitForm) { return }

            buttonSubmitForm.addEventListener("click", async function(event) {
                event.preventDefault();
                const elementVariantId = document.querySelector('.e-back-in-stock-product__variant');
                const elementEmail = document.querySelector('.e-back-in-stock-product__email');
                const elementFeedbackError = document.querySelector('.e-back-in-stock-product__error');
                const elementFeedbackSuccess = document.querySelector('.e-back-in-stock-product__success');
                const elementFormBackInStock = document.querySelector('.e-back-in-stock-product__form');
                if(!(elementVariantId && elementEmail)) { return }

                const variantId = elementVariantId.value;
                const email = elementEmail.value;

                if(email === "") {
                    elementFeedbackError.textContent = 'enter a valid email address.';
                    elementFeedbackError.classList.add('e-active');
                    return;
                }

                try {
                    await BackInStock.klayiyo.sendData({ email, variantId });
                    elementFeedbackSuccess.classList.add('e-active');
                    elementFormBackInStock.classList.add('e-disabled');
                } catch (error) {
                    elementFeedbackError.textContent = 'erro ao cadastrar, tente novamente.';
                    elementFeedbackError.classList.add('e-active');
                }

            })

        },

        monteSeuKit() {
            const buttonBackInStock = Array.from(document.querySelectorAll('button[data-backinstock]'));
            if(buttonBackInStock.length === 0) { new Error("elemento não encontrado") }

            buttonBackInStock.forEach(function(btn) {
                const productVariantId = btn.dataset.variantId;
                const productTitle = btn.dataset.productTitle;
                btn.addEventListener("click", function(event) {
                    BackInStock.handles.modal(event, productVariantId, productTitle);
                });
            });
        },

        quizDesodorantes() {
            // console.log(document.querySelector(".e-quiz-desodorantes__backinstock"))
        },

    },

    utils: {

        getCurrentPage() {
            const pathName = window.location.pathname;
            if(pathName.includes("monte-seu-kit")) { return "monte-seu-kit" }
            else if(pathName.includes("products")) { return "products" }
            else if(pathName.includes("resultado-quiz-desodorantes")) { return "resultado-quiz-desodorantes" }
            return null
        }

    },  

    init() {
        BackInStock.selectors.getSelectors();

        if(BackInStock.utils.getCurrentPage() === "products") {
            BackInStock.pages.product();
        }
        else if(BackInStock.utils.getCurrentPage() === "monte-seu-kit") {
            BackInStock.pages.monteSeuKit();
        }
        if(BackInStock.utils.getCurrentPage() === "resultado-quiz-desodorantes") {
            BackInStock.pages.quizDesodorantes();
        }
    }
}

window.addEventListener("load", function() {
    BackInStock.init();
});
